import React, { createContext, useReducer } from 'react';

const initialState = {
  open: false,
  message: null,
  icon: null,
  addedClubSerial: null,
};
const notificationContext = createContext(initialState);
const { Provider } = notificationContext;

const NotificationProvider = ({ children }) => {
  const [notificationState, notificationDispatch] = useReducer((contextState, action) => {
    const typeOptions = {
      SET_NOTIFICATION: {
        ...contextState,
        isOpen: action.isOpen,
        message: action.message,
        icon: action.icon,
        addedClubSerial: action.addedClubSerial,
      },
    };

    if (typeOptions[action.type]) {
      return typeOptions[action.type];
    }

    throw new Error();
  }, initialState);

  return <Provider value={{ notificationState, notificationDispatch }}>{children}</Provider>;
};

export { notificationContext, NotificationProvider };
